export const coverPlanCheckoutURL = (planId) => {
  const url = "/home-cover-plans/checkout?plan=" + planId
  return url
}
